import { render, staticRenderFns } from "./ShipmentCartonDetail.vue?vue&type=template&id=64274f16"
import script from "./ShipmentCartonDetail.vue?vue&type=script&lang=js"
export * from "./ShipmentCartonDetail.vue?vue&type=script&lang=js"
import style0 from "./ShipmentCartonDetail.vue?vue&type=style&index=0&id=64274f16&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports